import React from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Table from '~components/molecules/Table';
import UtilFunctions from '~utils/functions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { CustomerAccFundTypeEnum, CustomerIdTypeEnum, EarmarkReleaseRequestStatusEnum, GoldTypeEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_projectApprovalTableStyles.module.scss';
import combinedActions from '~redux/combinedActions';
import { TUpdateReleaseEarmarkStatusReduxParams } from '~types/feat/approval';

const ProjectApprovalTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc:
        {
            dateTimeFormat,
            renderPendingReleaseEarmarkStatusChip,
        },
    } = UtilFunctions;

    const pendingReleaseEarmarkListing = useAppSelector(state => state.approval.pendingReleaseEarmarkListing.data);
    const getPendingReleaseEarmarkListingIsLoading = useAppSelector(state => state.approval.loadings.getPendingReleaseEarmarkListing);

    const access = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Approval);

    const setTempUpdateReleaseEarmarkState = (data: TUpdateReleaseEarmarkStatusReduxParams) => dispatch(combinedActions.approvalSetTempUpdateReleaseEarmarkState(data));
    const setConfirmUpdateStatusModalIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateReleaseEarmarkStatusModalIsOpen(open));

    const handleApproveClick = (data: TUpdateReleaseEarmarkStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateReleaseEarmarkState(data);
    };

    const handleRejectClick = (data: TUpdateReleaseEarmarkStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateReleaseEarmarkState(data);
    };

    const tableHeader = [
        'TRANSACTION ID',
        'PROJECT NAME',
        'CUSTOMER NAME',
        'CUSTOMER ID TYPE',
        'CUSTOMER ID NUMBER',
        'CHILD ID NUMBER',
        'CHILD ID TYPE',
        'CHILD NAME',
        'CIF NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'PRODUCT NAME',
        'STATUS',
        'EARMARK AMOUNT',
        'FUND TYPE',
        'GOLD TYPE',
        'BRANCH TELLER NAME',
        'SALES PERSONNEL NAME',
        'REFERRAL NAME',
        'CREATED AT',
        'ACTION',
    ];

    const renderActionButton = (id: number, status:EarmarkReleaseRequestStatusEnum ) => {
        if (status === EarmarkReleaseRequestStatusEnum.Pending){
            return (
                <div
                    className={Styles['action-button-container']}
                >
                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Approve'
                            onClick={() => handleApproveClick({ id, status: EarmarkReleaseRequestStatusEnum.Approved })}
                            className={`${Styles['action-button']} ${Styles.approve}`}
                        />
                    )
                    }

                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Reject'
                            onClick={() => handleRejectClick({ id, status: EarmarkReleaseRequestStatusEnum.Rejected })}
                            className={`${Styles['action-button']} ${Styles.reject}`}
                        />
                    )
                    }
                </div>
            );
        }

        return '-';

    };

    const tableBody = pendingReleaseEarmarkListing.map((item, index) => {
        const {
            id,
            transactionId,
            projectName,
            customerName,
            customerIdType,
            customerIdNo,
            childIdNo,
            childIdType,
            childName,
            CIFNumber,
            branchCode,
            branchName,
            regionName,
            productName,
            status,
            earmarkAmount,
            fundType,
            goldType,
            branchTellerName,
            salesPersonnelName,
            referralName,
            createdAt,
        } = item;

        return [
            transactionId,
            projectName,
            customerName,
            CustomerIdTypeEnum[customerIdType] || '-',
            customerIdNo,
            childIdNo,
            CustomerAccFundTypeEnum[childIdType] || '-',
            childName,
            CIFNumber,
            branchCode,
            branchName,
            regionName,
            productName,
            renderPendingReleaseEarmarkStatusChip(status, EarmarkReleaseRequestStatusEnum[status]) || '-',
            earmarkAmount,
            CustomerAccFundTypeEnum[fundType] || '-',
            goldType ? GoldTypeEnum[goldType].split(/(?=[A-Z])/).join(' ') : '',
            branchTellerName,
            salesPersonnelName || '',
            referralName || '',
            createdAt ? dateTimeFormat(createdAt) : '-',
            renderActionButton(id, status),
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableBody}
            isLoading={getPendingReleaseEarmarkListingIsLoading}
        />
    );
};

export default ProjectApprovalTable;
